export default __webpack_public_path__ + "static/media/busIcon.3fbf32cf.svg";